import type { RouteObject } from 'react-router-dom';

import { ADMIN_ROLES } from '@/auth/roles';
import { RequireRole } from '@/auth/RequireRole';

/**
 * Import members area. OWNED BY `m3-clients` (M3b); see docs/BUILD-ORCHESTRATION.md.
 *
 *   /import           upload → check (mapping, fix once, per-row problems) → import → results
 *   /import/invites   "Invites to send": phone-only members still waiting for their link
 */
export const importRoutes: RouteObject[] = [
  {
    path: 'import',
    handle: { crumb: 'Import members' },
    // Owner and admin only: a trainer never sees this area (CLAUDE.md "Roles").
    element: <RequireRole roles={ADMIN_ROLES} />,
    children: [
      { index: true, lazy: async () => ({ Component: (await import('./ImportPage')).ImportPage }) },
      {
        path: 'invites',
        handle: { crumb: 'Invites to send' },
        lazy: async () => ({ Component: (await import('./InvitesQueuePage')).InvitesQueuePage }),
      },
    ],
  },
];
